function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.555,
  y: 0.555,
  width: 44.89,
  height: 44.89,
  rx: 1.445,
  fill: "white",
  stroke: "#AF6AF4",
  strokeWidth: 1.11
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8649 17.0357C35.8649 16.1408 35.2704 15.3548 34.4093 15.1112L30.2396 13.9315C29.5747 13.7434 29.054 13.2254 28.8625 12.5615L27.6749 8.44555C27.4279 7.58945 26.6443 7 25.7533 7H13.869C12.2845 7 11 8.27195 11 9.841V36.4833C11 38.0524 12.2845 39.3243 13.869 39.3243H32.9958C34.5804 39.3243 35.8649 38.0524 35.8649 36.4833V17.0357Z",
  fill: "#AF6AF4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4105 15.1112C35.2716 15.3548 35.866 16.1408 35.866 17.0357V36.4833C35.866 38.0524 34.5815 39.3243 32.997 39.3243H25.4336C24.329 39.3243 23.4336 38.4289 23.4336 37.3243V9C23.4336 7.89543 24.329 7 25.4336 7H25.7544C26.6455 7 27.429 7.58945 27.676 8.44555L28.8636 12.5615C29.0552 13.2254 29.5759 13.7434 30.2408 13.9315L34.4105 15.1112Z",
  fill: "#E1C3FF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5779 14.8602C35.8848 15.1335 35.5317 15.523 35.1208 15.523H29.1705C28.1185 15.523 27.2578 14.6707 27.2578 13.629V7.74857C27.2578 7.33515 27.6492 6.97812 27.9272 7.28416L35.5779 14.8602Z",
  fill: "#AF6AF4"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1707 22.2143H17.6946C17.166 22.2143 16.7383 21.7908 16.7383 21.2673C16.7383 20.7439 17.166 20.3203 17.6946 20.3203H29.1707C29.6993 20.3203 30.1271 20.7439 30.1271 21.2673C30.1271 21.7908 29.6993 22.2143 29.1707 22.2143Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1707 26.0034H17.6946C17.166 26.0034 16.7383 25.5798 16.7383 25.0564C16.7383 24.5329 17.166 24.1094 17.6946 24.1094H29.1707C29.6993 24.1094 30.1271 24.5329 30.1271 25.0564C30.1271 25.5798 29.6993 26.0034 29.1707 26.0034Z",
  fill: "white"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1707 29.7924H17.6946C17.166 29.7924 16.7383 29.3689 16.7383 28.8454C16.7383 28.322 17.166 27.8984 17.6946 27.8984H29.1707C29.6993 27.8984 30.1271 28.322 30.1271 28.8454C30.1271 29.3689 29.6993 29.7924 29.1707 29.7924Z",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3453 33.5796H17.6946C17.166 33.5796 16.7383 33.156 16.7383 32.6325C16.7383 32.1091 17.166 31.6855 17.6946 31.6855H25.3453C25.874 31.6855 26.3017 32.1091 26.3017 32.6325C26.3017 33.156 25.874 33.5796 25.3453 33.5796Z",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4336 32.6325C23.4336 33.1556 23.8576 33.5796 24.3806 33.5796H25.3463C25.8749 33.5796 26.3026 33.156 26.3026 32.6325C26.3026 32.1091 25.8749 31.6855 25.3463 31.6855H24.3806C23.8576 31.6855 23.4336 32.1095 23.4336 32.6325Z",
  fill: "#AF6AF4"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4336 28.8454C23.4336 29.3685 23.8576 29.7924 24.3806 29.7924H29.1716C29.7002 29.7924 30.128 29.3689 30.128 28.8454C30.128 28.322 29.7002 27.8984 29.1716 27.8984H24.3806C23.8576 27.8984 23.4336 28.3224 23.4336 28.8454Z",
  fill: "#AF6AF4"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4336 25.0564C23.4336 25.5794 23.8576 26.0034 24.3806 26.0034H29.1716C29.7002 26.0034 30.128 25.5798 30.128 25.0564C30.128 24.5329 29.7002 24.1094 29.1716 24.1094H24.3806C23.8576 24.1094 23.4336 24.5334 23.4336 25.0564Z",
  fill: "#AF6AF4"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4336 21.2693C23.4336 21.7923 23.8576 22.2163 24.3806 22.2163H29.1716C29.7002 22.2163 30.128 21.7927 30.128 21.2693C30.128 20.7458 29.7002 20.3223 29.1716 20.3223H24.3806C23.8576 20.3223 23.4336 20.7463 23.4336 21.2693Z",
  fill: "#AF6AF4"
});
function SvgUploadedFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFileIcon);
export default __webpack_public_path__ + "static/media/uploadedFileIcon.3c3be6fc.svg";
export { ForwardRef as ReactComponent };